import { render, staticRenderFns } from "./document-text.vue?vue&type=template&id=05f165d4&"
import script from "./document-text.vue?vue&type=script&lang=js&"
export * from "./document-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports